<template>
  <div>
    <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg  shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="w-full p-3 font-bold text-xl hover:bg-blue-400 mt-1 bg-blue-600 text-white rounded shadow"
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="flex justify-between p-8 text-sm border-t border-gray-300 bg-gray-100"
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>
    <div>
      <div v-if="numero" >
         <div class="box-content mx-52 mt-10 font-bold">
        <p
          class="text-blue-400 uppercase shadow-xl rounded text-center mt-2 bg-white w-auto p-5"
        >
          Maestro de AdministraciÓn de productos
        </p>
      </div>
          <modalProductos></modalProductos>
        <tablaProductos></tablaProductos>
        <modalEditarProductos></modalEditarProductos>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import modalProductos from "../components/modales/modalProductos.vue";
import tablaProductos from "../components/Tablas/tablaProductos.vue";
import modalEditarProductos from '../components/modales/modalEditarProductos'
export default {
  data() {
    return {
      falso: true,
    };
  },
  methods: {
    ...mapMutations(["value0", "value1"]),
  },
  components: { modalProductos, tablaProductos ,modalEditarProductos},
  name: "caracteristicas",
  computed: {
    ...mapState(["numero"]),
  },
};
</script>
<style>
</style>